import { Text } from '@cencosud-cencommerce/paris-uikit';

import {
  LABEL_KEEP_FOR_LATER,
  LABEL_PRODUCT_WILL_BE_REMOVED
} from '@/Pages/BuyNowPage/OutOfStock/constants';

export const OutOfStockInfo = () => {
  return (
    <div className="co-flex co-flex-col co-bg-neutral-200 co-rounded-xl co-p-4">
      <Text
        weight={600}
        className="co-text-neutral-800"
        variant="body2"
        element="p"
      >
        {LABEL_PRODUCT_WILL_BE_REMOVED}
        <Text variant="body2" element="span">
          {LABEL_KEEP_FOR_LATER}
        </Text>
      </Text>
    </div>
  );
};

OutOfStockInfo.displayName = 'OutOfStockInfo';

export default OutOfStockInfo;
